import { createSelector } from 'reselect';

import { getCoworkingPhotos } from '../dump/getCoworkingPhotos';

import { coworkingSelectedOfferSelector } from './coworkingSelectedOfferSelector';

export const getCoworkingGallery = createSelector(
  [getCoworkingPhotos, coworkingSelectedOfferSelector],
  (photos, selectedOffer) => {
    if (!selectedOffer) {
      return photos;
    }

    // Перемаппливаем поля картинок, чтобы галлерея могла их хавать
    const selectedOfferPhotos = selectedOffer.photos.map(({ full, mini, thumbnail }) => ({
      cianFull: full,
      cianMini: mini,
      cianThumbnail: thumbnail,
    }));

    return selectedOfferPhotos.concat(photos);
  },
);
